import React from 'react';
import { BarChart, Bar, CartesianGrid, XAxis, YAxis } from 'recharts';

import { useAppSelector } from 'src/hooks';
import {
    selectValues,
} from 'src/reducers/basicReducer';

// https://www.geeksforgeeks.org/create-a-bar-chart-using-recharts-in-reactjs/
const Bar_chart = () => {

    const values = useAppSelector(selectValues); // hook! (stateful)

    var test = 0
    if (values.length > 0) {
        for (let i = 0; i < values.length; i++) {
            if (values[i].heat_ssp126_2020) {
                test += values[i].heat_ssp126_2020;
            }
        }
    }

    // Sample data
    const data = [
        { name: 'Geeksforgeeks', students: test },
        { name: 'Technical scripter', students: 7 },
        { name: 'Geek-i-knack', students: 2 },
        { name: 'Geek-o-mania', students: 10 }
    ];


    return (
        <BarChart width={400} height={400} data={data}>
            <Bar dataKey="students" fill="green" />
            <CartesianGrid stroke="#ccc" />
            <XAxis dataKey="name" />
            <YAxis />
        </BarChart>
    );
}

export default Bar_chart;